module.exports = __webpack_public_path__ + "img/pg3-article-title3-inner.a968046f.png";